
import {
    RECEIVE_DEVICES,
    RESET,
    LOG_DEVICE_ERROR,
    RESET_DEVICE
} from "../constants";
import { DeviceState } from '../interfaces/states';
import { deviceActions } from "../actions/deviceActions";

const initialState: DeviceState = {
    devices: [],
    deviceIdentities: [],
    isFetching: false,
    error: null,
};


export default (state = initialState, action: deviceActions): DeviceState => {
    switch (action.type) {
        case RECEIVE_DEVICES: {
            return { ...state, devices: [...state?.devices, ...action?.devices] };
        }
         case RESET_DEVICE: {
             return initialState;
         }
        case LOG_DEVICE_ERROR: {
            return { ...state, error: { message: action.error?.message, type: action?.error?.response?.statusText } };
        }
        default: {
            return state;
        }

    }

}